import { LEGACY_OVERTIME_DIVISION_MAP, OvertimeDivision } from "../enums/overtime-division.enum";
import { OvertimeDivisionEntry, OvertimeSummaryWeek } from "../models/overtime-summary-week.model";

/** `yyyy-mm-dd` in local time — the same key `<input type="date">` produces. */
export function overtimeWeekDateKey(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

export function overtimeWeekDateFromKey(key: string): Date {
    const [y, m, d] = key.split('-').map(Number);
    return new Date(y, m - 1, d);
}

export function overtimeSummaryWeekId(weekOf: Date): string {
    return `ot-${overtimeWeekDateKey(weekOf)}`;
}

/** Folds legacy division names into their current bin and merges duplicate divisions. */
export function normalizeOvertimeWeek(week: OvertimeSummaryWeek): OvertimeSummaryWeek {
    const merged = new Map<OvertimeDivision, OvertimeDivisionEntry>();
    for (const entry of week.entries ?? []) {
        const division = LEGACY_OVERTIME_DIVISION_MAP[entry.division] ?? entry.division;
        const existing = merged.get(division);
        if (existing) {
            existing.hours += entry.hours || 0;
            existing.cost += entry.cost || 0;
        } else {
            merged.set(division, { division, hours: entry.hours || 0, cost: entry.cost || 0 });
        }
    }
    return { ...week, entries: [...merged.values()] };
}

export function overtimeWeekTotals(week: Pick<OvertimeSummaryWeek, 'entries'>): { hours: number; cost: number } {
    return week.entries.reduce(
        (acc, entry) => ({ hours: acc.hours + (entry.hours || 0), cost: acc.cost + (entry.cost || 0) }),
        { hours: 0, cost: 0 },
    );
}
